const csvTemplate = `subdistributor_code,outlet_name,outlet_code,outlet_sales_team,outlet_market_type,outlet_business_type,outlet_country,outlet_state,outlet_city,outlet_street,tax_name,tax_number,pkp,wht,is_active
CODE-1234,Kantor Kecantikan,C.9999,B2B Surabaya (BSB),GT,OFF,Indonesia,Kalimantan Timur,Kota Samarinda,-,Mr. Ahmad,0000000000000000,TRUE,npwp_badan,TRUE
CODE-1234,Toko Kosmetik,C.111,B2B Surabaya (BSB),GT,CSRB,Indonesia,Kalimantan Utara,Kota Tarakan,-,Mr. Charlie,1234567891011121,FALSE,npwp_pribadi,TRUE`;

export default csvTemplate;
